import React from "react";
import { Container, Form, Row, Col, Stack } from "react-bootstrap";
import arrow from "../../assets/icons/arrow-white.svg";
import arrowDark from "../../assets/icons/arrow-dark.svg";
import globe from "../../assets/icons/globe.svg";
import forms from "../../assets/icons/forms.svg";
import { Link } from 'react-router-dom';

const TODIS_LANDING_LINKS = () => {

    return (
        <Container fluid className="todis-landing-wrapper">
            <h2 className="text-center todis-header mb-5 todis-border-bottom">Be Up to Date</h2>
            <p className="todis-subtitle">Navigate through the desired module in the portal</p>
            <Row>
                <Col lg={6} className="p-4">
                    <Link to="/TODIS-APP/Datasharing"><Stack gap={3} className="todis-landing-links-container ">
                        <img src={globe} width="73" className="mx-auto" />
                        <h4 className="to-captial">Data Sharing</h4>
                    </Stack></Link>
                </Col>
                <Col lg={6} className="p-4">
                <Link to="/TODIS-APP/WorkFlow/"><Stack gap={3}  className="todis-landing-links-container">
                        <img src={forms} width="100" className="mx-auto"/>
                        <h4 className="to-captial">Data Collection</h4>
                    </Stack></Link>
                </Col>
            </Row>

        </Container>
    )
}

export default TODIS_LANDING_LINKS;